module.exports = __webpack_public_path__ + "static/media/image_computer.de6bd849.png";